import React from 'react'
import selectn from 'selectn'
import { bet365AffiliateCodes } from '../../../constants/bet365AffiliateCodes'

const BettingOdds = ({
  moduleOdds = {},
  situationNodeOdd = {},
  edition = ''
}) => {

  let detailsCode = selectn('editionDomain', edition) === 'www.espncricinfo.com' ? bet365AffiliateCodes.details : bet365AffiliateCodes.detailsEdition
  let findMoreCode = selectn('editionDomain', edition) === 'www.espncricinfo.com' ? bet365AffiliateCodes.findMore : bet365AffiliateCodes.findMoreEdition
  let detailsLink = detailsCode ? 'http://www.bet365.com/dl/~offer?affiliate=' + detailsCode : '#'
  let findMoreLink = findMoreCode ? 'http://www.bet365.com/dl/~offer?affiliate=' + findMoreCode : '#'

  let oddItems = selectn('items', moduleOdds) || {}
  let toWinNode = selectn('ToWIN', oddItems) || {}
  let toWinSpanCount = selectn('Draws.href', toWinNode) ? 2 : 3
  let toWinStyle = selectn('Draws.href', toWinNode) ? '#f9f9fb' : ''
  let homeTeamOdds = selectn('homeTeamOdds', toWinNode) || {}
  let awayTeamOdds = selectn('awayTeamOdds', toWinNode) || {}
  let draws = selectn('Draws', toWinNode) || {}
  let drawNoBet = selectn('DrawNoBet', toWinNode) || {}
  let playerDismissalMethod = selectn('PlayerDismissalMethod', oddItems) || {}
  let situationNodeOddItem = selectn('items', situationNodeOdd) || {}
  let toWinTheToss1 = selectn('ToWinTheToss[0]', oddItems) || {}
  let toWinTheToss2 = selectn('ToWinTheToss[1]', oddItems) || {}
  let manOfTheMatch =  selectn('ManOfTheMatch', oddItems) || []
  
  return (
   <article className="sub-module betting-odds" style={{ display: 'block' }}>
      <header>
        <h1>
          <a href={ detailsLink } target="_blank" className="external">Betting Odds</a>
          <a href={ detailsLink } target="_blank" className="betting-odds__powered-by">
            <div className="betting-odds__powered-by__title">Presented By</div>
            <div className="betting-odds__powered-by__logo">Bet365</div>
          </a>
        </h1>
      </header>
    
      <div className="content">
        {  oddItems &&
        <table className="betting-odds__table betting-odds__table--match-odds" cellSpacing="0">
          <tbody>
              { Object.keys(homeTeamOdds).length > 0 && Object.keys(awayTeamOdds).length > 0 &&
              <tr>
                  <td colSpan="2" className="betting-odds__table__label betting-odds__table__label--th">To Win</td>
                  <td colSpan={toWinSpanCount}><a href={ homeTeamOdds.href || '#' }>{ homeTeamOdds.teamAbbrev || ''} { homeTeamOdds.summary || ''}</a></td>
                  <td colSpan={toWinSpanCount} style={{ backgroundColor: toWinStyle }}><a href={ awayTeamOdds.href || '#' }>{ awayTeamOdds.teamAbbrev || ''} { awayTeamOdds.summary || ''}</a></td>
                  { draws.href && draws.href.length > 0 && draws.summary && draws.summary.length > 0 && 
                    <td colSpan={toWinSpanCount}><a href={draws.href || '#'}>DRAW {draws.summary || ''}</a></td>
                  }
              </tr>
              }
            { /* NEED TEAM ABBREVIATION HERE!!!!!!!! */ }
            { /* THIS IS TERRIBLE, really need the links to have home or away, or be identified some other way */ }
              { Object.keys(toWinTheToss1).length > 0 && Object.keys(toWinTheToss2).length > 0 &&
              <tr>
                  <td colSpan="2" className="betting-odds__table__label betting-odds__table__label--th">To Win Toss</td>
                  <td colSpan="3"><a href={toWinTheToss1.href || '#'}>{toWinTheToss1.displayName && toWinTheToss1.displayName.substring(0,3).toUpperCase() || ''} {toWinTheToss1.summary || ''}</a></td>
                  <td colSpan="3"><a href={toWinTheToss2.href || '#'}>{toWinTheToss2.displayName && toWinTheToss2.displayName.substring(0,3) || ''} {toWinTheToss2.summary || ''}</a></td>
              </tr>
              }
              { Object.keys(drawNoBet).length > 0 &&
              <tr>
                  <td colSpan="2" className="betting-odds__table__label betting-odds__table__label--th">Draw No Bet</td>
                  {
                    Object.keys(drawNoBet).map( (item, i) => {
                      return(
                        <td colSpan="3" key={i}><a href={ drawNoBet[item].href }>{item} { drawNoBet[item].summary }</a></td>
                      )
                    })
                  }
              </tr>
              }
              { Object.keys(playerDismissalMethod).length > 0 &&
              <tr>
                  <td colSpan="2" className="betting-odds__table__label betting-odds__table__label--th">Dismissal Method</td>
                  {
                    Object.keys(playerDismissalMethod).map( (item, i) => {
                      return(
                        <td colSpan="3" key={i}><a href={ playerDismissalMethod[item].href }>{item} { playerDismissalMethod[item].summary }</a></td>
                      )
                    })
                  }
              </tr>
              }
              {  Object.keys(situationNodeOddItem).length > 0 &&
              <tr>
                  <td colSpan="2" className="betting-odds__table__label betting-odds__table__label--th">Next Man Out</td>
                  {
                    Object.keys(situationNodeOddItem).map( (item, i) => {
                      return(
                        <td colSpan="3" key={i}><a href={situationNodeOddItem[item].href}>{item} { situationNodeOddItem[item].summary }</a></td>
                      )
                    })
                  }
              </tr>
              }
            </tbody>
        </table>
        }
        { manOfTheMatch.length > 0 &&
        <table className="betting-odds__table betting-odds__table--player-odds" cellSpacing="0">
          <tbody>
              <tr>
                  <th colSpan="4">Man of the Match</th>
              </tr>
              { 
                manOfTheMatch.map( (item, i) => { 
                  return (
                    <tr key={i}>
                      <td className="betting-odds__table__label" colSpan="2">{item.name}</td>
                      <td><a href={item.href}>{item.summary}</a></td>
                    </tr>
                  )
                })
              }
            </tbody>
        </table>
        }

        <div className="betting-odds__join">
          <div className="betting-odds__join__wrap">
            <a href={ detailsLink } target="_blank" className="betting-odds__join__logo">Bet365</a>
              <div className="betting-odds__join__content">
                <div className="betting-odds__join__title">New Customers Only</div>
                <div className="betting-odds__join__txt">Up to £100 in Bet Credits</div>
              </div>
          </div>
          <div className="betting-odds__join__cta">
            <a href={ detailsLink } className="button-alt med" target="_blank">Join Here</a>
          </div>
        </div>

        <div className="betting-odds__legal">
            <p>Sign up, deposit &#163;5 or more to your account and bet365 will match your qualifying deposit in Bet Credits when you place qualifying bets to the same value and they are settled. Min odds/bet and payment method exclusions apply. Returns exclude Bet Credits stake. T&Cs, time limits & exclusions apply. <a href={ detailsLink } target="_blank">More Details</a></p>
            <p className="betting-odds__legal__logos">
              <img src="http://a.espncdn.com/redesign/assets/img/logos/begambleawareorg_white_1400x182.png" />
              <img src="http://a.espncdn.com/redesign/assets/img/logos/logo_18plus_white_40x40.png" className="logo-eighteen-plus" />
            </p>
        </div>
      </div>

    <footer>
        <a href={ findMoreLink } target="_blank" className="view-more">Find More Odds</a>
    </footer>
    </article>
  )
}

export default BettingOdds



// WEBPACK FOOTER //
// ../app/components/common/col-c/BettingOdds.jsx